import { useMatch } from 'react-router';

import { BASIC_DATA_TABLE_DISPLAY_ROWS } from '@/features/Dashboard/constants/const';

import CommoditiesTableTab from './CommoditiesTableTab';

import type { CommoditiesTableSectionType } from '../types';

const CommoditiesTable = ({
  layout,
  sections
}: {
  sections: CommoditiesTableSectionType[] | undefined;
  layout?: { fullWidth?: boolean; height?: number };
}) => {
  const isDashboard = !!useMatch('/dashboard/*');
  const height = layout?.height ?? (isDashboard ? BASIC_DATA_TABLE_DISPLAY_ROWS : undefined);

  return (
    sections && (
      <CommoditiesTableTab
        height={height}
        sections={sections}
      />
    )
  );
};

export default CommoditiesTable;
